export default "/images/vendor/flag-icon-css/flags/1x1/aq.svg?e6c275d0d4e5135fb04baf7ebcaa8e6d";